import React from "react";

// prop-types is a library for typechecking of props

// react-select components
import { components } from "react-select";
import CreatableSelect from "react-select/creatable";

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";

// Custom styles for SoftSelect
import styles from "components/SoftSelect/styles";

const { ValueContainer, Placeholder } = components;

const CustomValueContainer = ({ children, ...props }) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.label}{" "}
        {props.selectProps.isRequired ? <span style={{ color: "#ff667c" }}>*</span> : ""}
      </Placeholder>
      {React.Children.map(children, (child) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};

const CreatableSoftSelect = ({
  size = "medium",
  error = false,
  success = false,
  onMenuOpen,
  menuPlacement = "auto",
  ref,
  ...rest
}) => {
  const { light } = colors;

  const onOpen = () => {
    setTimeout(() => {
      const listbox = document.querySelector(".css-1e83rmc-menu");

      if (listbox) {
        const clearHighlight = () => {
          const node = listbox.querySelector(".css-1qru4v0-option");

          if (node) {
            node.className = "css-1ourupj-option";
          }
        };

        clearHighlight();

        listbox.removeEventListener("mouseleave", clearHighlight);

        listbox.addEventListener("mouseleave", clearHighlight);
      }
    }, 0.5);
  };

  return (
    <CreatableSelect
      {...rest}
      ref={ref}
      styles={styles(size, error, success)}
      menuPlacement={menuPlacement}
      onMenuOpen={() => {
        if (typeof onMenuOpen === "function") {
          onMenuOpen();
        }
        onOpen();
      }}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: light.main,
          primary: light.main
        }
      })}
      components={{
        ...rest.components,
        ValueContainer: CustomValueContainer
      }}
    />
  );
};
export default CreatableSoftSelect;
